import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import "../../assets/css/faq.css";
import faq from "../../assets/img/landing/faq.svg";
import search from "../../assets/img/sreach---icon.svg";
import { getFaq } from "../../services/apiOtherlink";
const Faq = (props) => {
  const [searchKey, setSearchKey] = useState('');
  const [faqArr, setFaqArr] = useState([]);
  useEffect(() => {
    fetchFaq(searchKey)
  }, [])
  useEffect(() => {
    fetchFaq(searchKey)
  }, [searchKey])

  const fetchFaq = async (key) => {

    const formData = {
      searchkey: key,
      offset: 0,
      limit: 25
    }
   let faq = await getFaq(formData);
    setFaqArr(faq.faq)


  }
    const FaqClosePopup = () => {
    props.FaqClosePopup();
   
  };
  return (
    <div>
         <Modal dialogClassName="custom-modal modal-dialog-centered modal-dialog-scrollable" show={props.FaqOpenPopup} onHide={FaqClosePopup}>
           <Modal.Header closeButton>
             <div className="popupheader">
               <div className="mod-bor-icon" >
                 <img src={faq} className="mod-icon black"></img>
               </div>
               <div className="header">
                 <h4 className="modal-tittle">Frequently asked question</h4>
   
               </div>
             </div>
           </Modal.Header>
   
           <Modal.Body>
    <div class="">
        <div class="row ">
          <div class="col-lg-6 my-2 ">
            <div class="d-flex mb-3 ">
              <div class=" search-box search-wrapper  d-flex align-items-center px-2 gap-2">
                <span className="mobil-view-class border-end-0 ">
                  <img src={search} alt="search--Logo" className="search-logo-header mob-view-class pagess" />
                </span>
                <input type="text" class=" form-control border-start-0 search-inputs search-inside-color" placeholder="Search here"
                  onChange={(e) => { setSearchKey(e.target.value) }} value={searchKey} />
              </div>
            </div>
          </div>
        </div>


        <div class="row ">


          <div className="col-md-12">
            <div class="accordion popup" id="customAccordion">

              <div className="accordion" id="customAccordion">
                {faqArr.map((faQue, index) => (
                  <div className="accordion-item" key={index}>
                    <h2 className="accordion-header" id={`heading${index}`}>
                      <button
                        className="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${index}`}  // ✅ Corrected line
                        aria-expanded="false"
                        aria-controls={`collapse${index}`}
                      >
                        <div className="icon-text-wrapper">
                          <span className="custom-icon"></span>
                          <span className="custom-text">{faQue.question}</span>
                        </div>
                      </button>
                    </h2>
                    <div
                      id={`collapse${index}`}
                      className="accordion-collapse collapse"
                      aria-labelledby={`heading${index}`}
                      data-bs-parent="#customAccordion"
                    >
                      <div className="accordion-body">{faQue.answer}</div>
                    </div>
                  </div>
                ))}
              </div>       
            </div>
          </div>
        </div>


      </div>
           </Modal.Body>
           <Modal.Footer className="full-w" >
           
           </Modal.Footer>
         </Modal>
         
       </div>
  );
};
export default Faq;